import { isLoggedInAtom, presentLoginSheet } from 'app/atoms';
import { LoginSheet } from 'app/screens/onboarding/login';
import { useAtom, useAtomValue } from 'jotai';
import { Platform } from 'react-native';

export function GuestWebLoginHost() {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const loginSheetState = useAtom(presentLoginSheet);
  if (Platform.OS !== 'web' || isLoggedIn) return null;
  return <LoginSheet state={loginSheetState} />;
}
